import { useMemo } from 'react';
import { buildDefaultReconMismatchesTabs } from '../../../Blotters/Reconciliation/ReconMismatches/defaults';
import type { ReconMismatchesTabProps } from '../../../Blotters/Reconciliation/ReconMismatches/ReconMismatches';
import { MobileBlotterPanel, type MobileBlotterPanelProps } from './MobileBlotterPanel';

/** Placeholder-only mobile reconciliation content; uses `TradingPlaceholder` via `MobileBlotterPanel`. */
export function MobileReconMismatchesBlotter(
  props: Omit<MobileBlotterPanelProps<ReconMismatchesTabProps>, 'defaultTabs'>
) {
  const defaultTabs = useMemo(() => buildDefaultReconMismatchesTabs(), []);
  return <MobileBlotterPanel<ReconMismatchesTabProps> {...props} defaultTabs={defaultTabs} />;
}
